export const colors = {
  pink: '#e5d6e3',
  blue: '#c5ecfe',
  black: '#0e1414',
}
